import getRelatedClassName from './get-related-class-name';

const removeRelatedClassName = (node) => {
  node.classList.remove(getRelatedClassName(node.tagName.toLowerCase()));
  if (!node.classList.length) {
    node.removeAttribute('class');
  }
};

export default removeRelatedClassName;
